import Router from '@/router'
import { getToken } from '@/utils/auth'
import store from '@/store'

let channel = null
// 初始化全局监听是否需要重新登录
function initGlobalAuthListener() {
  // BroadcastChannel（主）
  if ('BroadcastChannel' in window) {
    channel = new BroadcastChannel('GLOBAL_AUTH_CHANNEL')
    channel.onmessage = (e) => {
      store.dispatch('user/set_menuList', []).then(() => {
        Router.push({ path: '/index', query: { sessionId: getToken() }})
      })
    }
  } else {
    // localStorage
    window.addEventListener('storage', (e) => {
      if (e.key === 'GLOBAL_RE_LOGIN_EVENT') {
        store.dispatch('user/set_menuList', []).then(() => {
          Router.push({ path: '/index', query: { sessionId: getToken() }})
        })
      }
    })
  }
}
initGlobalAuthListener()
